export enum STEPS {
  SETUP_PAYROLL = 1,
  CONNECT_BANK = 2,
}
